"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[516],{

/***/ 83900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowDown = function SvgArrowDown(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 256,
        height: 256,
        viewBox: "0 0 256 256"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        d: "M0 66.73c0 2.66.981 5.33 2.955 7.41l117.332 123.323a10.64 10.64 0 0 0 7.712 3.314c2.912 0 5.696-1.19 7.712-3.314L253.043 74.14c4.074-4.278 3.914-11.077-.331-15.163a10.627 10.627 0 0 0-15.083.333L128 174.536 18.379 59.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76 10.76 0 0 0 0 66.73"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowDown);


/***/ }),

/***/ 39160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ language_picker_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./constants/localization.js
var localization = __webpack_require__(72632);
// EXTERNAL MODULE: ./static/svg/earth.svg
var earth = __webpack_require__(39055);
// EXTERNAL MODULE: ./static/svg/arrow-down.svg
var arrow_down = __webpack_require__(83900);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./node_modules/react-onclickoutside/dist/react-onclickoutside.es.js
var react_onclickoutside_es = __webpack_require__(58949);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/language-picker/language-picker-dimensions.js
/* harmony default export */ var language_picker_dimensions = ({
    DIALOG_PADDING: 4,
    LANGUAGE_ITEM_HEIGHT: 32,
    LANGUAGE_ITEM_WIDTH: 104,
    LANGUAGE_ITEM_MARGIN: 4
});

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/language-picker/language-picker-dialog/language-picker-dialog-component.scss.js



var DIALOG_PADDING = "".concat(language_picker_dimensions.DIALOG_PADDING, "px");
var ITEM_MARGIN = "".concat(language_picker_dimensions.LANGUAGE_ITEM_MARGIN, "px");
var StyledLanguagePickerDialogComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1whntsv0"
})("border-radius:4px;background-color:white;box-shadow:0px 2px 20px rgba(0,0,0,0.1);padding:", DIALOG_PADDING, ";display:flex;flex-direction:column;flex-wrap:wrap;.language-picker-item-component-wrapper{margin:", ITEM_MARGIN, ";}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){flex-direction:row;overflow:auto;width:100% !important;max-height:186px;}");

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./components/core/language-picker/language-picker-dialog/language-picker-item/language-picker-item-component.scss.js



var ITEM_HEIGHT = "".concat(language_picker_dimensions.LANGUAGE_ITEM_HEIGHT, "px");
var ITEM_WIDTH = "".concat(language_picker_dimensions.LANGUAGE_ITEM_WIDTH, "px");
var _defaultExport = new String(".language-picker-item-component{height:".concat(ITEM_HEIGHT, ";width:").concat(ITEM_WIDTH, ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;padding:0px 8px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-transition:background-color 200ms ease;-moz-transition:background-color 200ms ease;-o-transition:background-color 200ms ease;transition:background-color 200ms ease;&:hover{background-color:").concat(colors/* default.riverstone */.Z.riverstone, "}&.language-selected{background-color:").concat(colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";.language-picker-item-label{color:").concat(colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], "}}.language-picker-item-label{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;line-height:").concat(ITEM_HEIGHT, ";font-size:.8125rem;color:").concat(colors/* default.text-gray */.Z["text-gray"], "}}"));
_defaultExport.__hash = "9a9101807314f977";
/* harmony default export */ var language_picker_item_component_scss = (_defaultExport);

;// CONCATENATED MODULE: ./components/core/language-picker/language-picker-dialog/language-picker-item/language-picker-item-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var LanguagePickerItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LanguagePickerItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LanguagePickerItemComponent);
    function LanguagePickerItemComponent(props) {
        (0,_class_call_check/* default */.Z)(this, LanguagePickerItemComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function() {
            var _props = _this.props, id = _props.id, onClick = _props.onClick;
            onClick(id);
        });
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.onClick);
        return _this;
    }
    (0,_create_class/* default */.Z)(LanguagePickerItemComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, label = _props.label, isSelected = _props.isSelected;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: this.onClick,
                    tabIndex: 0,
                    onKeyDown: this.onKeyDown,
                    role: "option",
                    "aria-selected": isSelected,
                    className: "jsx-".concat(language_picker_item_component_scss.__hash) + " " + (classnames_default()("language-picker-item-component", {
                        "language-selected": isSelected
                    }) || ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(language_picker_item_component_scss.__hash) + " " + "language-picker-item-label",
                            children: label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: language_picker_item_component_scss.__hash,
                            children: language_picker_item_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return LanguagePickerItemComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
;// CONCATENATED MODULE: ./components/core/language-picker/language-picker-dialog/language-picker-dialog-component.js





function language_picker_dialog_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            language_picker_dialog_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var LanguagePickerDialogComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LanguagePickerDialogComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LanguagePickerDialogComponent);
    function LanguagePickerDialogComponent(props) {
        (0,_class_call_check/* default */.Z)(this, LanguagePickerDialogComponent);
        var _this;
        _this = _super.call(this, props);
        language_picker_dialog_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onChangeLanguage", function(languageId) {
            var _props = _this.props, selectedLanguageId = _props.selectedLanguageId, closeDialog = _props.closeDialog;
            closeDialog();
            if (selectedLanguageId !== languageId) {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.LANGUAGE_PICKER_LANG_CHANGED, {
                    info1: languageId,
                    info2: selectedLanguageId
                });
                (0,cookies_service/* setCookie */.d8)(localization.USER_SELECTED_LOCALE_ID_COOKIE, languageId);
                window.location.reload();
            }
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(LanguagePickerDialogComponent, [
        {
            key: "handleClickOutside",
            value: function handleClickOutside() {
                var closeDialog = this.props.closeDialog;
                closeDialog();
            }
        },
        {
            key: "getNumberOfLanguageItemsInColumn",
            value: function getNumberOfLanguageItemsInColumn() {
                var _props = this.props, languages = _props.languages, maxElementsInColumn = _props.maxElementsInColumn;
                return languages.length <= maxElementsInColumn ? languages.length : Math.min(maxElementsInColumn, Math.ceil(languages.length / 2));
            }
        },
        {
            key: "getComponentStyle",
            value: function getComponentStyle() {
                return {
                    height: this.getComponentHeight(),
                    width: this.getComponentWidth()
                };
            }
        },
        {
            key: "getComponentHeight",
            value: function getComponentHeight() {
                var totalPadding = language_picker_dimensions.DIALOG_PADDING * 2;
                var numberOfElementsInColumn = this.getNumberOfLanguageItemsInColumn();
                var totalElementsHeight = language_picker_dimensions.LANGUAGE_ITEM_HEIGHT * numberOfElementsInColumn;
                var totaElementsPadding = language_picker_dimensions.LANGUAGE_ITEM_MARGIN * numberOfElementsInColumn * 2;
                return totalPadding + totalElementsHeight + totaElementsPadding;
            }
        },
        {
            key: "getComponentWidth",
            value: function getComponentWidth() {
                var _props = this.props, languages = _props.languages, maxElementsInColumn = _props.maxElementsInColumn;
                var totalPadding = language_picker_dimensions.DIALOG_PADDING * 2;
                var numberOfElementsInRow = Math.ceil(languages.length / maxElementsInColumn);
                var totalElelementsWidth = language_picker_dimensions.LANGUAGE_ITEM_WIDTH * numberOfElementsInRow;
                var totaElementsPadding = language_picker_dimensions.LANGUAGE_ITEM_MARGIN * numberOfElementsInRow * 2;
                return totalPadding + totalElelementsWidth + totaElementsPadding;
            }
        },
        {
            key: "renderLanguageItems",
            value: function renderLanguageItems() {
                var _this = this;
                var _props = this.props, languages = _props.languages, selectedLanguageId = _props.selectedLanguageId;
                return languages.map(function(language, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "language-picker-item-component-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguagePickerItemComponent, _object_spread_props(_object_spread({}, language), {
                            isSelected: selectedLanguageId === language.id,
                            onClick: _this.onChangeLanguage
                        }))
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var style = this.getComponentStyle();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLanguagePickerDialogComponent, {
                    className: "language-picker-dialog-component",
                    style: style,
                    role: "listbox",
                    children: this.renderLanguageItems()
                });
            }
        }
    ]);
    return LanguagePickerDialogComponent;
}(react.PureComponent);
LanguagePickerDialogComponent.defaultProps = {
    maxElementsInColumn: 5
};
/* harmony default export */ var language_picker_dialog_component = ((0,react_onclickoutside_es/* default */.Z)(LanguagePickerDialogComponent));

// EXTERNAL MODULE: ./components/core/language-picker/language-picker-service.js
var language_picker_service = __webpack_require__(42803);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/core/language-picker/language-picker-component.scss.js






var language_picker_component_scss_ITEM_WIDTH = "".concat(language_picker_dimensions.LANGUAGE_ITEM_WIDTH, "px");
var language_picker_component_scss_ITEM_HEIGHT = "".concat(language_picker_dimensions.LANGUAGE_ITEM_HEIGHT, "px");
var StyledLanguagePickerComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1twum250"
})("position:relative;&:hover,&.is-open{.earth-icon{path{stroke:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";}}.selected-language{.language-label{color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";}}.arrow-down-icon{path{fill:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";}}}&.is-open{.selected-language{.arrow-down-icon{transform:translateY(1px) rotate(180deg);}}.language-picker-dialog-component-wrapper{opacity:1;visibility:visible;}}.selected-language{display:flex;align-items:center;cursor:pointer;user-select:none;height:", language_picker_component_scss_ITEM_HEIGHT, ";line-height:", language_picker_component_scss_ITEM_HEIGHT, ";.earth-icon{path{transition:stroke 150ms ease;color:", colors/* default.text-gray */.Z["text-gray"], ";}}.language-label{font-size:0.875rem;margin:0px 8px;max-width:", language_picker_component_scss_ITEM_WIDTH, ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;transition:color 150ms ease;color:", colors/* default.text-gray */.Z["text-gray"], ";}.arrow-down-icon{height:10px;width:10px;transform:translateY(1px);transition:transform 200ms ease;path{fill:", colors/* default.text-gray */.Z["text-gray"], ";transition:fill 150ms ease;}}}.language-picker-dialog-component-wrapper{position:absolute;top:40px;opacity:0;visibility:hidden;transition:opacity 200ms ease;z-index:", z_index/* LANGUAGE_PICKER_MENU */.Sj, ";&.left{left:0;}&.right{right:0;}&.top{top:calc((-40 * var(--number-of-lang-rows)) * 1px - 16px);}&.bottom{.language-picker-dialog-component{border-top-left-radius:0;border-top-right-radius:0;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, ") and (min-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){.language-picker-dialog-component{position:absolute;top:0;right:0;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){.language-picker-dialog-component-wrapper{&.top{top:-200px;}}}");

;// CONCATENATED MODULE: ./components/core/language-picker/language-picker-component.js





function language_picker_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}














var MIN_WINDOW_DISTANCE = 200;
var LEFT_DIRECTION = "left";
var RIGHT_DIRECTION = "right";
var MAX_LANGUAGES_ROWS = 5;
var LanguagePickerComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LanguagePickerComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LanguagePickerComponent);
    function LanguagePickerComponent(props) {
        (0,_class_call_check/* default */.Z)(this, LanguagePickerComponent);
        var _this;
        _this = _super.call(this, props);
        language_picker_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "openDialog", function() {
            var selectedLanguageId = _this.state.selectedLanguageId;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.LANGUAGE_PICKER_OPENED, {
                info1: selectedLanguageId
            });
            _this.setState({
                isDialogOpen: true
            });
        });
        language_picker_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "closeDialog", function() {
            _this.setState({
                isDialogOpen: false
            });
        });
        language_picker_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "toggleDialog", function() {
            var isDialogOpen = _this.state.isDialogOpen;
            if (isDialogOpen) {
                _this.closeDialog();
            } else {
                _this.openDialog();
            }
        });
        _this.state = {
            isDialogOpen: false,
            selectedLanguageId: props.userSelectedLanguage || props.localeId || localization.ENGLISH_LOCALE_ID,
            horizontalDirection: LEFT_DIRECTION
        };
        var defaultLanguages = props.showMainLanguagesOnly ? language_picker_service/* MAIN_LANGUAGES_VALUES */.pS : Object.values(language_picker_service/* LANGUAGES */.a2);
        var overrideLanguages = props.overrideLanguages ? (0,language_picker_service/* getLanguagesByIds */.Q9)(props.overrideLanguages) : null;
        _this.languages = overrideLanguages && overrideLanguages.length > 0 ? overrideLanguages : defaultLanguages;
        _this.getHorizontalDirection = _this.getHorizontalDirection.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.toggleDialog);
        return _this;
    }
    (0,_create_class/* default */.Z)(LanguagePickerComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.addEventListener("resize", this.getHorizontalDirection);
                this.getHorizontalDirection();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("resize", this.getHorizontalDirection);
            }
        },
        {
            key: "getHorizontalDirection",
            value: function getHorizontalDirection() {
                if (!this.selector) return;
                var horizontalDirection = LEFT_DIRECTION;
                var horizontalPosition = this.selector.getBoundingClientRect().right;
                if ((window.innerWidth || document.documentElement.clientWidth) - horizontalPosition < MIN_WINDOW_DISTANCE) {
                    horizontalDirection = RIGHT_DIRECTION;
                }
                this.setState({
                    horizontalDirection: horizontalDirection
                });
            }
        },
        {
            key: "getShortLabel",
            value: function getShortLabel() {
                var selectedLanguageId = this.state.selectedLanguageId;
                var selectedLanguage = language_picker_service/* LANGUAGES */.a2[selectedLanguageId];
                var shortLabel = selectedLanguage.shortLabel;
                return shortLabel.toUpperCase();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _state = this.state, isDialogOpen = _state.isDialogOpen, selectedLanguageId = _state.selectedLanguageId;
                var _props = this.props, dialogDirection = _props.dialogDirection, useShortLabels = _props.useShortLabels, translate = _props.translate, showLabel = _props.showLabel;
                var selectedLanguage = language_picker_service/* LANGUAGES */.a2[selectedLanguageId];
                if (!selectedLanguage) {
                    esm_exports/* captureMessage */.uT("Selected language Id is: ".concat(selectedLanguageId, ", and it is not supported in the language picker."));
                    selectedLanguage = language_picker_service/* LANGUAGES */.a2[localization.ENGLISH_LOCALE_ID];
                }
                var label = selectedLanguage.label;
                var horizontalDirection = this.state.horizontalDirection;
                var labelToShow = useShortLabels ? this.getShortLabel() : label;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLanguagePickerComponent, {
                    className: classnames_default()("language-picker-component", {
                        "is-open": isDialogOpen
                    }),
                    ref: function(el) {
                        _this.selector = el;
                    },
                    tabIndex: 0,
                    "aria-haspopup": "true",
                    "aria-expanded": isDialogOpen,
                    "aria-label": translate("languagePicker.chooseLanguageLabel"),
                    onKeyDown: this.onKeyDown,
                    role: "combobox",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "selected-language ignore-clickoutside",
                            onClick: this.toggleDialog,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(earth/* default */.Z, {
                                    className: "earth-icon"
                                }),
                                showLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "language-label",
                                    children: labelToShow
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down/* default */.Z, {
                                    className: "arrow-down-icon"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("language-picker-dialog-component-wrapper", dialogDirection, horizontalDirection),
                            style: {
                                "--number-of-lang-rows": Math.min(this.languages.length, MAX_LANGUAGES_ROWS)
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(language_picker_dialog_component, {
                                languages: this.languages,
                                selectedLanguageId: selectedLanguageId,
                                closeDialog: this.closeDialog,
                                outsideClickIgnoreClass: "ignore-clickoutside"
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return LanguagePickerComponent;
}(react.PureComponent);
LanguagePickerComponent.defaultProps = {
    localeId: localization.ENGLISH_LOCALE_ID,
    useShortLabels: false,
    showLabel: true
};
/* harmony default export */ var language_picker_component = ((0,generic_config_context/* withGenericConfig */.P)(LanguagePickerComponent));


/***/ }),

/***/ 42803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Df": function() { return /* binding */ DIALOG_DIRECTIONS; },
/* harmony export */   "Q9": function() { return /* binding */ getLanguagesByIds; },
/* harmony export */   "a2": function() { return /* binding */ LANGUAGES; },
/* harmony export */   "pS": function() { return /* binding */ MAIN_LANGUAGES_VALUES; }
/* harmony export */ });
/* unused harmony export MAIN_LANGUAGES_KEYS */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var constants_localization__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72632);
/* harmony import */ var constants_localization__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_localization__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63105);
/* harmony import */ var lodash_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_filter__WEBPACK_IMPORTED_MODULE_1__);



var DIALOG_DIRECTIONS = {
    ALIGN_TOP: "top",
    ALIGN_BOTTOM: "bottom"
};
var _obj;
var LANGUAGES = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_localization__WEBPACK_IMPORTED_MODULE_0__.ENGLISH_LOCALE_ID, {
    id: constants_localization__WEBPACK_IMPORTED_MODULE_0__.ENGLISH_LOCALE_ID,
    label: "English",
    shortLabel: constants_localization__WEBPACK_IMPORTED_MODULE_0__.ENGLISH_LOCALE_ID,
    flag: "\uD83C\uDDFA\uD83C\uDDF8"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_localization__WEBPACK_IMPORTED_MODULE_0__.SPANISH_LOCALE_ID, {
    id: constants_localization__WEBPACK_IMPORTED_MODULE_0__.SPANISH_LOCALE_ID,
    label: "Espa\xf1ol",
    shortLabel: constants_localization__WEBPACK_IMPORTED_MODULE_0__.SPANISH_LOCALE_ID,
    flag: "\uD83C\uDDF2\uD83C\uDDFD"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_localization__WEBPACK_IMPORTED_MODULE_0__.FRENCH_LOCALE_ID, {
    id: constants_localization__WEBPACK_IMPORTED_MODULE_0__.FRENCH_LOCALE_ID,
    label: "Fran\xe7ais",
    shortLabel: constants_localization__WEBPACK_IMPORTED_MODULE_0__.FRENCH_LOCALE_ID,
    flag: "\uD83C\uDDEB\uD83C\uDDF7"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_localization__WEBPACK_IMPORTED_MODULE_0__.GERMAN_LOCALE_ID, {
    id: constants_localization__WEBPACK_IMPORTED_MODULE_0__.GERMAN_LOCALE_ID,
    label: "Deutsch",
    shortLabel: constants_localization__WEBPACK_IMPORTED_MODULE_0__.GERMAN_LOCALE_ID,
    flag: "\uD83C\uDDE9\uD83C\uDDEA"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_localization__WEBPACK_IMPORTED_MODULE_0__.PORTUGEESE_LOCALE_ID, {
    id: constants_localization__WEBPACK_IMPORTED_MODULE_0__.PORTUGEESE_LOCALE_ID,
    label: "Portugu\xeas",
    shortLabel: constants_localization__WEBPACK_IMPORTED_MODULE_0__.PORTUGEESE_LOCALE_ID,
    flag: "\uD83C\uDDF5\uD83C\uDDF9"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_localization__WEBPACK_IMPORTED_MODULE_0__.DUTCH_LOCALE_ID, {
    id: constants_localization__WEBPACK_IMPORTED_MODULE_0__.DUTCH_LOCALE_ID,
    label: "Nederlands",
    shortLabel: constants_localization__WEBPACK_IMPORTED_MODULE_0__.DUTCH_LOCALE_ID,
    flag: "\uD83C\uDDF3\uD83C\uDDF1"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_localization__WEBPACK_IMPORTED_MODULE_0__.ITALIAN_LOCALE_ID, {
    id: constants_localization__WEBPACK_IMPORTED_MODULE_0__.ITALIAN_LOCALE_ID,
    label: "Italiano",
    shortLabel: constants_localization__WEBPACK_IMPORTED_MODULE_0__.ITALIAN_LOCALE_ID,
    flag: "\uD83C\uDDEE\uD83C\uDDF9"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_localization__WEBPACK_IMPORTED_MODULE_0__.RUSSIAN_LOCALE_ID, {
    id: constants_localization__WEBPACK_IMPORTED_MODULE_0__.RUSSIAN_LOCALE_ID,
    label: "Pусский",
    shortLabel: constants_localization__WEBPACK_IMPORTED_MODULE_0__.RUSSIAN_LOCALE_ID,
    flag: "\uD83C\uDDF7\uD83C\uDDFA"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_localization__WEBPACK_IMPORTED_MODULE_0__.JAPANESE_LOCALE_ID, {
    id: constants_localization__WEBPACK_IMPORTED_MODULE_0__.JAPANESE_LOCALE_ID,
    label: "日本語",
    shortLabel: constants_localization__WEBPACK_IMPORTED_MODULE_0__.JAPANESE_LOCALE_ID,
    flag: "\uD83C\uDDEF\uD83C\uDDF5"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_localization__WEBPACK_IMPORTED_MODULE_0__.KOREAN_LOCALE_ID, {
    id: constants_localization__WEBPACK_IMPORTED_MODULE_0__.KOREAN_LOCALE_ID,
    label: "한국어",
    shortLabel: constants_localization__WEBPACK_IMPORTED_MODULE_0__.KOREAN_LOCALE_ID,
    flag: "\uD83C\uDDF0\uD83C\uDDF7"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_localization__WEBPACK_IMPORTED_MODULE_0__.TURKISH_LOCALE_ID, {
    id: constants_localization__WEBPACK_IMPORTED_MODULE_0__.TURKISH_LOCALE_ID,
    label: "T\xfcrk\xe7e",
    shortLabel: constants_localization__WEBPACK_IMPORTED_MODULE_0__.TURKISH_LOCALE_ID,
    flag: "\uD83C\uDDF9\uD83C\uDDF7"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_localization__WEBPACK_IMPORTED_MODULE_0__.SWEDISH_LOCALE_ID, {
    id: constants_localization__WEBPACK_IMPORTED_MODULE_0__.SWEDISH_LOCALE_ID,
    label: "Svenska",
    shortLabel: constants_localization__WEBPACK_IMPORTED_MODULE_0__.SWEDISH_LOCALE_ID,
    flag: "\uD83C\uDDF8\uD83C\uDDEA"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_localization__WEBPACK_IMPORTED_MODULE_0__.POLISH_LOCALE_ID, {
    id: constants_localization__WEBPACK_IMPORTED_MODULE_0__.POLISH_LOCALE_ID,
    label: "Polski",
    shortLabel: constants_localization__WEBPACK_IMPORTED_MODULE_0__.POLISH_LOCALE_ID,
    flag: "\uD83C\uDDF5\uD83C\uDDF1"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_localization__WEBPACK_IMPORTED_MODULE_0__.CHINESE_LOCALE_ID, {
    id: constants_localization__WEBPACK_IMPORTED_MODULE_0__.CHINESE_LOCALE_ID,
    label: "繁體中文",
    shortLabel: constants_localization__WEBPACK_IMPORTED_MODULE_0__.CHINESE_LOCALE_ID,
    flag: "\uD83C\uDDE8\uD83C\uDDF3"
}), _obj);
var MAIN_LANGUAGES_KEYS = [
    constants_localization__WEBPACK_IMPORTED_MODULE_0__.ENGLISH_LOCALE_ID,
    constants_localization__WEBPACK_IMPORTED_MODULE_0__.SPANISH_LOCALE_ID,
    constants_localization__WEBPACK_IMPORTED_MODULE_0__.PORTUGEESE_LOCALE_ID,
    constants_localization__WEBPACK_IMPORTED_MODULE_0__.FRENCH_LOCALE_ID,
    constants_localization__WEBPACK_IMPORTED_MODULE_0__.GERMAN_LOCALE_ID
];
var getLanguagesByIds = function(ids) {
    return lodash_filter__WEBPACK_IMPORTED_MODULE_1___default()(LANGUAGES, function(language) {
        return ids.includes(language.id);
    });
};
var MAIN_LANGUAGES_VALUES = getLanguagesByIds(MAIN_LANGUAGES_KEYS);


/***/ }),

/***/ 83826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ AI_COLORED_STAR_ICON; }
/* harmony export */ });
var AI_COLORED_STAR_ICON = "https://dapulse-res.cloudinary.com/image/upload/Subtract.svg";


/***/ })

}]);